import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { AutotextService } from 'src/app/autotext.service';
import { ExamsService } from 'src/app/exams.service';
import { UsgService } from 'src/app/usg.service';

@Component({
    selector: 'app-detail-finding',
    templateUrl: './detail-finding.component.html',
    styleUrls: ['./detail-finding.component.scss'],
    standalone: false
})
export class DetailFindingComponent implements OnInit {
  @Input('data') item;
  @Input('id') id;
  @Input('dbName') dbName:string;

  form:UntypedFormControl;
  constructor(public gs:UsgService, public es:ExamsService, public atS:AutotextService) { }

  ngOnInit() {
  }

}
